import Vue from 'vue';
import Vuex from 'vuex';
import { 
  cartsList,
  cartsCheck,
  cartsCheckAll,
  cartsDel,
  invalidDel,
  cartsNumChange
} from '@/api/shopCart'
Vue.use(Vuex);


const state = {
    
}
const mutations = {
    
}
const actions = {
  CARTLIST(){
    return new Promise((resolve) => {        
      cartsList().then(response => {
        if (response && response.code === 200) {
          resolve(response);
        }  
      })
    })
  },
  CARTCHECK(context, params){
    return new Promise((resolve) => {        
      cartsCheck(params).then(response => {
        if (response && response.code === 200) {
          resolve(response);
        }  
      })
    })
  },
  CARTCHECKALL(context, params){
    return new Promise((resolve) => {        
      cartsCheckAll(params).then(response => {
        if (response && response.code === 200) {
          resolve(response);
        }  
      })
    })
  },
  CARTDEL(context, {id}){
    return new Promise((resolve) => {            
      cartsDel(id).then(response => {
        if (response && response.code === 200) {
          resolve(response);
        }  
      })
    })
  },
  INVALIDDEL(context, params){
    return new Promise((resolve) => {            
      invalidDel().then(response => {
        if (response && response.code === 200) {
          resolve(response);
        }  
      })
    })
  },
  CARTSNUMBER(context, params){
    console.log('params',params)
    return new Promise((resolve) => {            
      cartsNumChange(params).then(response => {
        if (response && response.code === 200) {
          resolve(response);
        }  
      })
    })
  }, 
}
const getters = {  
    
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}